import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { StorageService } from './storage.service';

@Injectable()
export class NumericValidationService {
  isArabic!:boolean;
  constructor(private storageService: StorageService) { 
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
  }

    checkNumericValue(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let regex = new RegExp("^([0-9]*)$");
            let onlyNumbers;
            if (regex.test(control.value)) {
                onlyNumbers = true;
            }
            let errMsg;
            if(this.isArabic) {
              errMsg =  "يسمح فقط بالأرقام";
            } else  {
              errMsg = 'Only numbers are allowed';
            }
          return onlyNumbers ? null : {numeric: {errorMsg : errMsg}};
        };
      }
}
